var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { AddImageIcon, Button, StateConfigContext, Typography, checkIsPlatform, getTestId, useBreakpoint, BLACK_700 } from '@airtel/air-design-system';
import { useCallback, useContext } from 'react';
import { Text, TextInput, View } from 'react-native';
import { getUploadContainerStyles, getUploadContainerUIProp } from './UploadContainerStyles';
export var UploadContainer = props => {
  var _a;
  var _props$id = props.id,
    id = _props$id === void 0 ? (_a = new Date()) === null || _a === void 0 ? void 0 : _a.getTime() : _props$id,
    testID = props.testID,
    prefixTitle = props.prefixTitle,
    _props$uploadCtaTitle = props.uploadCtaTitle,
    uploadCtaTitle = _props$uploadCtaTitle === void 0 ? 'Choose file' : _props$uploadCtaTitle,
    _props$onUploadCtaPre = props.onUploadCtaPress,
    onUploadCtaPress = _props$onUploadCtaPre === void 0 ? {} : _props$onUploadCtaPre,
    postfixTitle = props.postfixTitle,
    description = props.description,
    onUserAction = props.onUserAction,
    _props$allowFileUploa = props.allowFileUploadOnWeb,
    allowFileUploadOnWeb = _props$allowFileUploa === void 0 ? false : _props$allowFileUploa,
    _props$title = props.title,
    title = _props$title === void 0 ? '' : _props$title,
    restProps = __rest(props, ["id", "testID", "prefixTitle", "uploadCtaTitle", "onUploadCtaPress", "postfixTitle", "description", "onUserAction", "allowFileUploadOnWeb", "title"]);
  var _useBreakpoint = useBreakpoint({
      returnAsObject: true
    }),
    isLargeScreen = _useBreakpoint.isLargeScreen;
  var _useContext = useContext(StateConfigContext),
    theme = _useContext.theme;
  var uploadContainerStyles = getUploadContainerStyles(isLargeScreen, props, theme);
  var containerUIProps = getUploadContainerUIProp(isLargeScreen, theme);
  var uploadBtnId = "upload-btn-" + id;
  var BlankSpace = () => _jsx(Text, {
    children: " "
  });
  var uploadBtnRef = useCallback(node => {
    if (checkIsPlatform('web') && node != null) {
      node.setAttribute('id', uploadBtnId);
      node.setAttribute('type', 'file');
      node.setAttribute('style', 'visibility: hidden; display: none');
    }
  }, []);
  var uploadLabelRef = useCallback(node => {
    if (checkIsPlatform('web') && node != null) {
      node.setAttribute('for', uploadBtnId);
    }
  }, []);
  return _jsxs(View, Object.assign({}, restProps, getTestId(testID), {
    children: [!!title && _jsx(Typography, Object.assign({
      style: uploadContainerStyles.title,
      text: title,
      type: "body-single-line-xs",
      color: BLACK_700
    }, getTestId(testID, 'title'))), _jsxs(View, Object.assign({
      style: uploadContainerStyles.container
    }, {
      children: [_jsx(View, Object.assign({
        style: uploadContainerStyles.addImageIcon
      }, {
        children: _jsx(AddImageIcon, Object.assign({}, containerUIProps.addImageIcon))
      })), _jsxs(View, Object.assign({
        style: uploadContainerStyles.textDescContainer
      }, {
        children: [_jsxs(View, Object.assign({
          style: uploadContainerStyles.textContainer
        }, {
          children: [!!prefixTitle && _jsx(Typography, Object.assign({}, containerUIProps.titlePrefixPostfix, {
            text: prefixTitle
          })), _jsx(BlankSpace, {}), allowFileUploadOnWeb && checkIsPlatform('web') && _jsxs(_Fragment, {
            children: [_jsx(TextInput, {
              ref: uploadBtnRef,
              onChange: event => {
                onUploadCtaPress && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
                  id
                }, onUploadCtaPress), {
                  uploadCtaTitle,
                  event
                }));
              }
            }), _jsx(Typography, {
              accessibilityRole: "label",
              type: "button-text-" + containerUIProps.uploadCta.buttonType + "-" + containerUIProps.uploadCta.size,
              text: uploadCtaTitle,
              ref: uploadLabelRef,
              style: uploadContainerStyles.uploadCta
            })]
          }), !allowFileUploadOnWeb && _jsx(Button, Object.assign({}, containerUIProps.uploadCta, {
            isCapitalize: false,
            title: uploadCtaTitle,
            style: uploadContainerStyles.uploadCta,
            onPress: () => {
              onUploadCtaPress && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
                id
              }, onUploadCtaPress), {
                uploadCtaTitle
              }));
            }
          })), _jsx(BlankSpace, {}), !!postfixTitle && _jsx(Typography, Object.assign({}, containerUIProps.titlePrefixPostfix, {
            text: postfixTitle
          }))]
        })), !!description && _jsx(Typography, Object.assign({}, containerUIProps.description, {
          style: uploadContainerStyles.description,
          text: description
        }))]
      }))]
    }))]
  }));
};